<template>
  <div class="captcha-container">
    <p></p>
    <div>Captcha - zaznacz okno z literą: <span :class="'span-'+bnumber"></span></div>
    <div class="d-flex caption-box align-items-center justify-content-center">
      <div v-for="n in 6" :key="n" class="col-2 text-center captcha-option" :class="['val-'+(7-n), {active: this.bcheck === n}]" @click="cClick(n)"></div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue";

export default {
  props: {
    modelValue: Number,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      bnumber: this.getRn(),
      bcheck: null,
    }
  },
  mounted() {
    this.getRn()
  },
  methods: {
    getRn() {
      this.bnumber = ref(Math.floor(Math.random() * 6) + 1)
    },
    cClick(n) {
      if (this.bcheck === n) {
        this.$emit("update:modelValue", null);
        this.bcheck = null;
        return;
      }
      this.$emit("update:modelValue", Number(`${n}${this.bnumber}`));
      this.bcheck = n;
    }
  },
}
</script>

<style scoped>
.span-1::after {
  content: "F";
}

.span-2::after {
  content: "E";
}

.span-3::after {
  content: "D";
}

.span-4::after {
  content: "C";
}

.span-5::after {
  content: "B";
}

.span-6::after {
  content: "A";
}

.val-6::after {
  content: "A";
}

.val-5::after {
  content: "B";
}

.val-4::after {
  content: "C";
}

.val-3::after {
  content: "D";
}

.val-2::after {
  content: "E";
}

.val-1::after {
  content: "F";
}

.captcha-container {
  width: 100%;
  border: 1px dashed gray;
  border-radius: 10px;
  background: #ffffff24;
  text-align: center;
}

.caption-box {
  height: 100px;
}

.captcha-option {
  cursor: pointer;
  padding:20px 5px;
  margin: 2px;
  border:1px solid rgb(43 43 43);
  border-radius: 5px;
  background-color: #dadada;
  color: #202020;
  font-size: 20px;
  transition: all 0.2s ease-in-out;
}

.captcha-option.active {
  background-color: #e5bf00;
  color: #ffffff;
  border:1px solid #e5bf00;
  text-shadow: 0px 0px 5px black;
  font-weight: bold;
}

.captcha-option:hover {
  background-color: #e5bf00;
  color: #ffffff;
  border:1px solid #e5bf00;
}
</style>